import { Component } from "@angular/core";
import { isEmbedded } from "@app/shared/resources/embedded-mobile-checker";

@Component({
    selector: "clare-not-found",
    templateUrl: "./not-found.component.html",
    styleUrls: ["./not-found.component.scss"],
})
export class NotFoundComponent {
    public isEmbedded = isEmbedded;
}
